import type { Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { unref } from 'vue'
import type { Geofence } from '@gpx-spa/geo-domain'
import { getApi } from './api'

interface GetAccountGeofencesParams {
  [key: string]: unknown
}

/**
 * Lists account geofences. Drops rows without a usable center (`lat`/`lng`) so consumers that expect coordinates do not break.
 */
export default (
  accountId: Ref<number> | number,
  params?: Ref<GetAccountGeofencesParams> | GetAccountGeofencesParams
) => {
  return useQuery({
    queryKey: ['account-geofences', () => unref(accountId), () => unref(params)],
    queryFn: async () => {
      const { api, baseURL } = getApi()
      const actualAccountId = unref(accountId)
      const actualParams = unref(params) || {}

      const res = await api.get(`/api/accounts/${actualAccountId}/geofences`, {
        baseURL,
        params: actualParams,
      })
      const rows = res.data?.data
      if (!Array.isArray(rows)) return [] as Geofence[]
      const validGeofences = rows.filter(
        (item: Geofence) => item.lat && item.lng,
      )
      return validGeofences as Geofence[]
    },
    enabled: !!unref(accountId),
  })
}
